module.exports = __webpack_public_path__ + "img/acc-pro.d63b9378.png";